import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");
export const SITE_NAME = "sportsshields.ie";
const DEFAULT_IMAGE = `${SITE_URL}/img/og-home.jpg`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

// Per-page title, description, canonical, social tags, robots and JSON-LD.
export const useSeo = ({ title, description, path, image = DEFAULT_IMAGE, noindex = false, jsonLd, canonical }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE_URL}${path ?? pathname}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setLink("canonical", canonical ? `${SITE_URL}${canonical}` : url);
    [["og:title", title], ["og:description", description], ["og:url", url], ["og:image", image]].forEach(([k, v]) => setMeta("property", k, v));
    [["twitter:title", title], ["twitter:description", description], ["twitter:image", image]].forEach(([k, v]) => setMeta("name", k, v));
    let ld = document.getElementById("ld-page");
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "ld-page"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, path, pathname, image, noindex, jsonLd, canonical]);
};

export const breadcrumbs = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, p], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${p}` })),
});

export const ORGANIZATION = {
  "@type": "Organization",
  "@id": `${SITE_URL}/#org`,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/img/logo.png`,
  areaServed: "IE",
};

// Private, per-customer pages: never indexed.
export const usePrivatePage = (title) => useSeo({ title: `${title} | ${SITE_NAME}`, description: "Private page.", noindex: true });
